
<template>
  <v-card color="transparent" flat tile>
    <v-card-title class="justify-center">
      <h1 class="indigo--text text--darken-4">Curriculum vitae <i class="fas fa-id-card"></i></h1>
    </v-card-title>
    <v-tabs dark color="indigo darken-4" background-color="blue-grey lighten-3" v-model="activeItem">
      <v-tab v-for="(item, index) in items" :class="activeItem!=index ? 'blue-grey--text text--darken-2' : ''" :key="'tab-'+index" @click="activeItem=index">{{ item.label }}</v-tab>
    </v-tabs>
    <v-window v-model="activeItem">
      <v-window-item v-for="(item, index) in items" :value="index" :key="index">
          <component v-bind:is="items[activeItem].name"></component>
      </v-window-item>
    </v-window>
    <v-card-actions class="justify-space-between">
      <v-btn text @click="activeItem--" :disabled="(activeItem==0)">
        <v-icon>fa-chevron-left</v-icon>
      </v-btn>
      <v-item-group v-model="activeItem" class="text-center" mandatory>
        <v-item v-for="(item, n) in items" :key="`btn-${n}`" v-slot="{ active, toggle }">
          <v-btn :input-value="active" icon @click="toggle">
            <v-icon>fa-circle</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-btn text @click="activeItem++" :disabled="(activeItem==items.length-1)">
        <v-icon>fa-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Identity from '@/components/Cv/Identity.vue'
import Learnings from '@/components/Cv/Learnings.vue'
import Jobs from '@/components/Cv/Jobs.vue'
import Languages from '@/components/Cv/Languages.vue'
import Skills from '@/components/Cv/Skills.vue'
import Qualities from '@/components/Cv/Qualities.vue'
export default {
  name: 'Cv',
  components: { Identity, Learnings, Jobs, Languages, Skills, Qualities },
  data: () => ({
    activeItem: 0,
    items: [ 
      { name:'Identity', label:'Etat civil' }, 
      { name:'Learnings', label:'Formations' }, 
      { name:'Jobs', label:'Expériences professionnelles' },
      { name:'Languages', label:'Langues' },
      { name:'Skills', label:'Compétences' },
      { name:'Qualities', label:'Caractère' },
    ]
  }),
}
</script>

